import { connect } from 'react-redux';
import Course from './course';
import {
  onLoadCourses,
  onLoadCourse,

} from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.courses.isLoadingCards,
  course: state.courses.selectedCourse,
  cards: state.courses.currentCards,
  courses: state.courses.previewCourses,
});

const mapDispatchToProps = dispatch => ({
  loadCourse: (course) => {
    dispatch(onLoadCourse(course));
  },
  onLoadCourses: () => dispatch(onLoadCourses()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Course);



// WEBPACK FOOTER //
// ./src/app/main/course-all/course.container.js